import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Etage} from '../../../models/etage.model';
import {Piece} from '../../../models/piece.model';
import {DossierInterventionService} from '../../../services/dossier_intervention.service';
import {UserService as AuthUserService} from '../../../core/user/user.service';
import {formatDate} from '@angular/common';
import {ActiviteEau} from '../../../models/activiteEau.model';

@Component({
    selector: 'app-modal-activite-eau',
    templateUrl: './modal-activite-eau.component.html'
})
export class ModalActiviteEauComponent implements OnInit {
    @Input() activiteEau: ActiviteEau;
    @Input() activitesEaux: Array<ActiviteEau> = []; //List of previous activiteEaux
    @Input() pieces: Array<Piece> = [];
    @Input() etages: Array<Etage> = [];

    formattedEtages: Array<Etage> = [];
    setFormattedEtages(): void {
        this.formattedEtages = [ new Etage({ id: 0, nom_niveau: 'Extérieur'}), ...this.etages ];
    }

    error: boolean = false;
    form: FormGroup;


    constructor(
        private dossierInterventionService: DossierInterventionService,
        private authUserService: AuthUserService,
        public dialogRef: MatDialogRef<ModalActiviteEauComponent>,
    ) {
    }

    ngOnInit(): void {
        let etage_id = this.activiteEau.dossier_intervention_activite_eau.etage_id;
        if (this.activiteEau.id && this.activiteEau.dossier_intervention_activite_eau.etage_id === null) {
            etage_id = 0;
        }

        this.form = new FormGroup({
            id: new FormControl(this.activiteEau.id),
            etage_id: new FormControl(etage_id, [Validators.required]),
            piece_id: new FormControl(this.activiteEau.dossier_intervention_activite_eau.piece_id),

            visit_date: new FormControl(formatDate(this.activiteEau.visit_date ?? new Date(), 'yyyy-MM-dd', 'en'), [Validators.required]),
            humidity: new FormControl(this.activiteEau.humidity, [Validators.required]),
            temperature: new FormControl(this.activiteEau.temperature, [Validators.required]),
            gpl: new FormControl(this.activiteEau.gpl, [Validators.required]),
        });

        this.form.valueChanges.subscribe(values=>this.onFormChange(values));

        this.setFormattedEtages();
    }

    onFormSubmit(): void {
        this.error = false;
        this.form.markAllAsTouched();

        if (this.form.valid) {
            const activiteEau = this.activiteEau;
            const values = this.form.value;

            activiteEau.visit_date = values.visit_date;
            activiteEau.humidity = values.humidity;
            activiteEau.temperature = values.temperature;
            activiteEau.gpl = values.gpl;

            activiteEau.dossier_intervention_activite_eau.etage_id = values.etage_id === 0 ? null : values.etage_id;
            activiteEau.dossier_intervention_activite_eau.piece_id = values.piece_id;

            this.dossierInterventionService.storeOrUpdateActiviteEauxForDossierIntervention(
                activiteEau.dossier_intervention_activite_eau.dossier_intervention_id,
                activiteEau
            ).subscribe(
                (response) => {
                    this.dialogRef.close(response);
                }, (error) => {
                    this.error = true;
                }
            );

        }
    }

    onFormChange(values: any) {
        if(values.etage_id === 0) {
            this.form.setControl('piece_id', new FormControl(null));
        } else {
            this.form.setControl('piece_id', new FormControl(values.piece_id, [Validators.required]));
        }
    }
}
